import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkinRadiusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 4,
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 8
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 1.5,
			d: "M12 4V2m0 20v-2m-8-8H2m20 0h-2"
		})
	]
});
export default SvgSkinRadiusIcon;
